<template>
  <div class="sidenav">
    <el-menu
      :router="true"
      :default-active="$route.path"
      background-color="#ffecb3"
    >
      <el-menu-item :index="home">
        <span>首頁</span>
      </el-menu-item>

      <template v-for="(item, index) in items">
        <el-menu-item
          :index="item.path"
          :key="index"
        >
          <span>{{ item.label }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { items } from '@/helpers/resourcesItems'

export default {
  name: 'sidenav',
  data () {
    return {
      home: '/',
      items: items
    }
  }
}
</script>
